import i18n from "./i18n";
import API from "../Network/API";

// Set once the visitor picks a language themselves; location is never used after that.
const CHOSEN_KEY = "xller_lang_chosen";
// Set once the location lookup has run, so it only happens on the first visit.
const GEO_KEY = "xller_geo_locale";

function storageGet(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function storageSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {}
}

// The language API requests should be answered in (sent as the X-Locale header).
export function currentLanguage() {
  return (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);
}

// Display currency (see services/currency.js; kept as a plain key here to avoid a circular import).
const CURRENCY_KEY = "xller_currency";

// On the first visit, pick the site language and display currency from the visitor's country
// (e.g. UAE -> Arabic + AED). Visitors who already have a language get just the currency once.
export async function applyGeoLocale() {
  const needLanguage = !storageGet(CHOSEN_KEY) && !storageGet(GEO_KEY);
  const needCurrency = !storageGet(CURRENCY_KEY);
  if (!needLanguage && !needCurrency) return;
  try {
    const response = await API.get("/v1/oauth/geo-locale", { timeout: 2000 });
    const { locale, currency } = response.data?.data || {};
    if (needCurrency) storageSet(CURRENCY_KEY, currency || "USD");
    if (needLanguage) {
      storageSet(GEO_KEY, locale || "none");
      if (locale && locale !== currentLanguage() && i18n.options.supportedLngs.includes(locale)) {
        await i18n.changeLanguage(locale);
      }
    }
  } catch (e) {
    // Location lookup is best effort; keep the detected browser language and USD, and don't
    // retry (and delay first render) on every page load.
    if (needLanguage) storageSet(GEO_KEY, "none");
    if (needCurrency) storageSet(CURRENCY_KEY, "USD");
  }
}

// Manual switch from the language menu. Reloads so content already fetched from the API
// (courses, categories) is fetched again in the new language.
export function switchLanguage(lng) {
  storageSet(CHOSEN_KEY, lng);
  if (lng === currentLanguage()) return;
  i18n.changeLanguage(lng).then(() => window.location.reload());
}
